import { useCallback, useEffect, useRef, useState } from 'react'
import type { LexicalEditor as LexicalEditorClass } from 'lexical'

import { useOutsideClick } from 'hooks'

import type { ITextEditor } from './text-editor.types'
import { editorStateToHTML } from './text-editor.utils'

export const useTextEditorModel = ({ textContent, handleTextChange, isViewMode }: ITextEditor) => {
  const [hasFocus, setHasFocus] = useState(false)

  const componentref = useRef(null)
  const { isClickOutside } = useOutsideClick(componentref)

  const handleChange = useCallback(
    (editorState: any, editor: LexicalEditorClass) => {
      if (isViewMode) {
        return
      }
      editorState.read(() => {
        const html = editorStateToHTML(editor)

        handleTextChange(html)
      })
    },
    [handleTextChange, isViewMode]
  )

  useEffect(() => {
    if (isViewMode) {
      return
    }
    setHasFocus(!isClickOutside)
  }, [isClickOutside, isViewMode])

  return { handleChange, hasFocus, textValue: textContent, componentref }
}
